module.exports = __webpack_public_path__ + "static/media/RedInfo.4f88f204.svg";